import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	getSlackConfigurationErrorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-title-non-final',
		defaultMessage: "We couldn't connect the workspace",
		description: 'Error title when slack API fails',
	},
	getSlackConfigurationErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-description-non-final',
		defaultMessage: 'Wait a moment or refresh the page before trying again.',
		description: 'Error when slack API fails',
	},
	slackNotConnectedTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-not-connected-title-non-final',
		defaultMessage: 'Couldn’t connect your Slack workspace',
		description: 'Title of error flag for slack connection already existing.',
	},
	slackAuthoriseErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-authorise-error-description-non-final',
		defaultMessage: 'Your Slack workspace couldn’t be authenticated. Please try again.',
		description:
			'Description of error flag shown after Slack could not be connected to JSM site due to auth issues.',
	},
	connectionAlreadyExistsDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.connection-already-exists-description-non-final',
		defaultMessage:
			'Your Slack workspace is already connected to a different Jira Service Management site. Disconnect your workspace from the other site and try again.',
		description: 'Description of error flag for slack connection already existing.',
	},
	connectionFailedDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.connection-failed-description-non-final',
		defaultMessage:
			'Something went wrong. Please try connecting again or contact support for help.',
		description:
			'Description to be shown for the error flag of connection creation failed for slack.',
	},
	slackSupportBtnLabelNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-support-btn-label-non-final',
		defaultMessage: 'Contact support',
		description: 'Button label for Contacting Support.',
	},
	somethingWentWrongTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.something-went-wrong-title-non-final',
		defaultMessage: 'Something went wrong',
		description: 'Title for generic error or forbidden tenant for slack integration.',
	},
	slackContactSupportDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-contact-support-description-non-final',
		defaultMessage: 'Please try again or contact support for help.',
		description: 'Description for multiple slack error code flags.',
	},
	slackConnectAgainDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-connect-again-description-non-final',
		defaultMessage: 'Please try connecting your workspace again.',
		description: 'Description of error flag to be shown for multiple suitable scenarios.',
	},
	slackSessionExpiredTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-session-expired-title-non-final',
		defaultMessage: 'Slack session expired',
		description: 'Title for slack link expired error code.',
	},
	slackWorkspaceMismatchTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-workspace-mismatch-title-non-final',
		defaultMessage: 'You aren’t a member of the Slack workspace',
		description: 'Title for slack workspace mismatch error code.',
	},
	slackWorkSpaceMissmatchDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-slack-connection.slack-work-space-missmatch-description-non-final',
		defaultMessage:
			'Looks like you aren’t part of the Slack workspace you’re trying to connect with Jira. Join the Slack workspace and try again.',
		description: 'Description for slack workspace mismatch error code.',
	},
});
